import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import type SessionContextService from 'tio-employee/services/session-context';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedTuitionAssistanceDependentProgramsRoute extends Route {
  @service declare store: Store;
  @service declare sessionContext: SessionContextService;
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const currentEmployee = this.sessionContext.currentEmployee;
    const employeeId = currentEmployee.id as string;

    const [tasData, employeeResult] = await Promise.all([
      this.reimaginedData.fetchDependentTasData(),
      this.store.request(
        findRecord<EmployeeModel>('employee', employeeId, {
          include: 'dependents',
          reload: true,
        })
      ),
    ]);
    const employee = (employeeResult as { content: { data: EmployeeModel } }).content.data;

    // Compute enrolled template IDs from the dependent applications
    const enrolledTemplateIds = new Set(
      tasData.applications
        .filter((app) => app.programTemplateId)
        .map((app) => app.programTemplateId as string)
    );

    const eligibleTemplates =
      await this.reimaginedData.fetchDependentEligibleTemplates(enrolledTemplateIds);

    return {
      tasData,
      eligibleTemplates,
      employee,
    };
  }
}
